var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./clojure.string.js");
'use strict';$CLJS.dA=new $CLJS.M(null,"form","form",-1624062471);